import { Button, Stack, Typography } from '@mui/material'
import { EquipmentType } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { IFormStore } from '@tom-ui/utils'
import { useState } from 'react'
import { IOperationalEquipmentFormData } from '../../models/operational-equipment-assignment.model'

interface Props {
  equipmentType: EquipmentType
  equipmentCount: number
  formStore: IFormStore<IOperationalEquipmentFormData>
  onConfirm: () => void
}
export const OperationalEquipmentConfirm = ({
  equipmentType,
  equipmentCount,
  formStore,
  onConfirm,
}: Props) => {
  const { t } = useTranslate()
  const [open, setOpen] = useState(false)

  const vesselAssignmentCount =
    formStore.data.vesselAssignments?.assignments.filter(a => a.isDeleted !== true).length ?? 0
  const trainAssignmentCount =
    formStore.data.trainAssignments?.assignments.filter(a => a.isDeleted !== true).length ?? 0
  const yardAssignmentCount =
    formStore.data.yardAssignments?.assignments.filter(a => a.isDeleted !== true).length ?? 0

  return (
    <>
      <Button
        variant='contained'
        color='primary'
        onClick={() => setOpen(true)}
        data-cy='operational-equipment-save-btn'
      >
        {t('submit', 'Submit')}
      </Button>

      <ConfirmationDialog
        open={open}
        title={t('confirmation', 'Confirmation')}
        primaryActionText={t('yes', 'Yes')}
        primaryActionDataCy='operational-equipment-confirm-btn'
        closeLabel={t('cancel', 'Cancel')}
        onConfirm={() => {
          onConfirm()
          setOpen(false)
        }}
        onClose={() => setOpen(false)}
      >
        <Stack gap={2}>
          <Typography variant='subtitle2' color='secondary'>
            {t('changestoXEquipment', 'Changes to {equipmentCount} {equipmentType} equipment:', {
              equipmentCount,
              equipmentType: equipmentType,
            })}
          </Typography>
          <Stack component='ul' sx={{ pl: 2 }}>
            <Typography component='li' variant='subtitle2' color='secondary'>
              {t('assigningTo', 'You are assigning to ')}
              {t('countVessels', '{vessel} vessels', {
                value: vesselAssignmentCount,
                vessel: vesselAssignmentCount,
              })}
              {t('comma', ', ')}
              {t('countTrains', '{train} trains', {
                value: trainAssignmentCount,
                train: trainAssignmentCount,
              })}
              {t('and', ' and ')}
              {t('countBlocks', '{block} block', {
                value: yardAssignmentCount,
                block: yardAssignmentCount,
              })}
            </Typography>
          </Stack>

          <Typography variant='subtitle2' color='secondary'>
            {t('doYouWantToProceed', 'Do you want to proceed?')}
          </Typography>
        </Stack>
      </ConfirmationDialog>
    </>
  )
}
